import { FaGamepad, FaUserEdit, FaMoneyBillWave } from 'react-icons/fa';

function HowPlay() {

    const steps = [
        {
            id: 1,
            image: './assets/images/icon/new_file.jpeg',
            title: "Subscription",
            description: "Choose your favorite game and start playing"
        },
        {
            id: 2,
            image: './assets/images/icon/how-play-icon-2.png',
            title: "Play",
            description: "Win games and receive your rewards instantly"
        },
        {
            id: 3,
            image: './assets/images/icon/how-play-icon-3.png',
            title: "Get Reward",
            description: "Subscribe and start winning rewards"
        }
    ];

    return (
        <div className="relative overflow-hidden mt-20 rounded-[18px] w-[90%] xl:w-[88%] md:w-[88%] lg:w-[80%] mx-auto">

            {/* 🔥 GLOW BACKGROUND */}
            <div className="absolute left-[-150px] top-[-100px] w-[300px] h-[300px] rounded-full 
            bg-gradient-to-br from-[#ff003c] to-[#6a00ff] opacity-10 blur-[120px]"></div>

            <div className="absolute right-[-150px] bottom-[-100px] w-[300px] h-[300px] rounded-full 
            bg-gradient-to-tr from-[#ff003c] to-[#6a00ff] opacity-10 blur-[120px]"></div>

            <div className="relative bg-[#0f0f1a] rounded-[18px] p-6 sm:p-10">

                <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-center">

                    {/* LEFT IMAGE */}
                    <div className="hidden md:block lg:col-span-2 flex justify-center">
                        <div className="relative">
                            <div className="absolute inset-0 bg-gradient-to-r from-[#ff003c]/20 to-[#6a00ff]/20 rounded-full blur-3xl"></div>

                            <img
                                src="./assets/how-play-illus.webp"
                                alt="Gamer"
                                className="relative w-80 h-90 object-cover rounded-2xl"
                            />
                        </div>
                    </div>

                    {/* RIGHT */}
                    <div className="lg:col-span-3">

                        <h2 className="text-white text-2xl lg:text-5xl font-bold text-center mb-12">
                            How To <span className="text-[#ff003c]">Play</span>
                        </h2>

                        {/* STEPS */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">

                            {steps.map((step) => (
                                <div
                                    key={step.id}
                                    className="flex flex-col items-center text-center group"
                                >

                                    <div className="relative mb-4">

                                        {/* STEP NUMBER */}
                                        <div className="absolute -top-4 -left-4 
                                        bg-gradient-to-r from-[#ff003c] to-[#6a00ff] 
                                        text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg shadow-lg">
                                            {step.id}
                                        </div>

                                        {/* ICON BOX */}
                                        <div className="p-6 rounded-2xl bg-[#141422] 
                                        border border-[#ffffff10]
                                        group-hover:border-[#ff003c]
                                        transition-all duration-300 
                                        group-hover:scale-110
                                        shadow-[0_10px_20px_rgba(255,0,60,0.1)]
                                        group-hover:shadow-[0_0_20px_rgba(255,0,60,0.4)]">

                                            <img
                                                src={step.image}
                                                className="h-[80px] mx-auto"
                                                alt={step.title}
                                            />
                                        </div>
                                    </div>

                                    {/* TITLE */}
                                    <h3 className="text-white text-xl font-bold 
                                    group-hover:text-[#ff003c] transition">
                                        {step.title}
                                    </h3>

                                    {/* DESCRIPTION */}
                                    <p className="text-gray-400 text-sm mt-2">
                                        {step.description}
                                    </p>

                                </div>
                            ))}

                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default HowPlay;